import React from "react";
import { Link } from "react-router-dom";

const ForexMarketContentTwo = () => {
  return (
    <div className="how__work__market">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Forex Market Insights</h2>

                <p>
                  Currency prices fluctuate based on economic data, interest
                  rate changes, and global market sentiment. At The Pips,
                  traders benefit from real-time data feeds, analytical tools,
                  and reliable charting systems to stay ahead of trends.
                </p>
              </div>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/images/markets/forex_cfd/forex_2.png"
                }
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Interest Rates</h3>
              <p>
                Central bank interest rate decisions strongly influence currency
                value by affecting foreign investment inflows and overall
                demand.
              </p>
              <hr className="black-line" />
              <h3> Inflation and Economic Indicators</h3>
              <p>
                Key data like inflation, GDP, and employment shape currency
                strength by revealing a country’s economic stability or
                weakness.
              </p>
              <hr className="black-line" />
              <h3>Geopolitical Stability and Global Events</h3>
              <p>
                Political stability and global events can significantly impact
                currency movements, with tensions driving traders toward
                safe-haven assets.
              </p>
              <hr className="black-line" />
              <h3>Market Sentiment and Speculation</h3>
              <p>
                Trader psychology, news-driven expectations, and speculative
                activity often drive short-term price swings in the forex
                market.
              </p>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForexMarketContentTwo;
